import { useState, useEffect } from 'react';
import { getTimePhase, getGreeting, getPhaseConfig } from '../temporal';

/**
 * Reactive time-of-day hook.
 * Re-renders every 15 minutes to update the phase.
 */
export function useTimeOfDay() {
  const [phase, setPhase] = useState(getTimePhase());

  useEffect(() => {
    const timer = setInterval(() => {
      const newPhase = getTimePhase();
      setPhase(prev => prev !== newPhase ? newPhase : prev);
    }, 15 * 60 * 1000); // every 15 minutes
    return () => clearInterval(timer);
  }, []);

  return {
    phase,
    greeting: getGreeting(),
    config: getPhaseConfig(phase),
  };
}
